import { Component, inject, Output, EventEmitter } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TenantService } from '../../../shared/services/tenant.service';

@Component({
  selector: 'app-add-tenant',
  imports: [FormsModule, CommonModule],
  templateUrl: './add-tenant.html',
})
export class AddTenantComponent {
  private tenantService = inject(TenantService);

  @Output() close = new EventEmitter<void>();

  isSubmitting = false;

  tenantData = {
    name: ''
  };

  async onSubmit() {
    if (!this.tenantData.name.trim()) {
      alert('Please enter a tenant name');
      return;
    }

    this.isSubmitting = true;
    try {
      await this.tenantService.createTenant(this.tenantData.name.trim());
      this.tenantData.name = '';
      this.close.emit();
    } catch (error) {
      console.error(error);
      alert('Error while creating tenant');
    } finally {
      this.isSubmitting = false;
    }
  }

  closeModal() {
    this.close.emit();
  }
}
